import React from "react";

import {
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    NumberInput,
    SelectInput,
    required,
} from "react-admin";

import {
    TableCell,
    TableRow,
} from "@material-ui/core";

import { useForm } from "react-final-form";
import { isDiscrete } from "./ExternalIsolatesCreate";

const standardChoices = [
    { id: "S", name: "Susceptible" },
    { id: "I", name: "Intermediate" },
    { id: "R", name: "Resistant" },
    { id: "U", name: "Unknown" },
]

export const AntibioticInterpretationField = (props) => {
    const index = props.index;
    const DeleteButton = props.deleteButton;
    const form = useForm();
    var formdata = form.getState().values;
    const values = formdata.antibiotics_interpretations;
    let discrete = isDiscrete(values[index]);
    if (!discrete) {
        return (<TableRow
            key={index}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >
            <TableCell component="th" scope="row">
                <ReferenceInput
                    label="Antibiotico"
                    source={"antibiotics_interpretations[" + index + "].id_antibiotic"}
                    reference="antibiotics"
                    filter={{ isDiscrete: false }}
                    validate={required()}
                >
                    <AutocompleteInput
                        resettable={true}
                        clearAlwaysVisible={true}
                        optionText="name"
                        suggestionLimit={10}
                    />
                </ReferenceInput>
            </TableCell>
            <TableCell align="left">
                <SelectInput
                    label="Interpretacion"
                    source={"antibiotics_interpretations[" + index + "].mic_interpretation"}
                    choices={standardChoices}
                />
            </TableCell>
            <TableCell align="left">
                <SelectInput
                    label="Operator"
                    source={"antibiotics_interpretations[" + index + "].mic_operator"}
                    choices={[
                        { id: "le", name: "<=" },
                        { id: "lt", name: "<" },
                        { id: "ge", name: ">=" },
                        { id: "gt", name: ">" },
                        { id: "eq", name: "=" },
                        { id: "ne", name: "!=" },
                    ]}
                />
            </TableCell>
            <TableCell align="left">
                <NumberInput
                    source={"antibiotics_interpretations[" + index + "].mic_value"}
                    label="Mic Value"
                    step={1}
                />
            </TableCell>
            <TableCell align="left">
                <TextInput
                    source={"antibiotics_interpretations[" + index + "].notes"}
                    label="Notes"
                />
            </TableCell>
            <DeleteButton index={index}></DeleteButton>
        </TableRow>);
    }
    return (null);
}
